import { Component, OnInit } from '@angular/core';
import { Product, PRODUCT_FEATURE, ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-product-feature',
    templateUrl: './kn-br-product-feature.component.html',
    styleUrl: './kn-br-product-feature.component.scss',
    imports: [AsyncPipe]
})
export class KnBrProductFeatureComponent{
  isAccesories?: boolean;
 product$: Observable<Product | null> = this.service
          .getProduct([ProductScope.DETAILS])
        constructor(
          protected service: CurrentProductService    
        ){}
}
